import React, { useCallback, useState } from 'react'
import {
  BooleanInput,
  SimpleForm,
  TextInput,
  Confirm,
  email,
  required,
  ReferenceInput,
  AutocompleteInput,
  // minLength,
  useTranslate,
  useUpdate,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin'
// import PersonIcon from '@mui/icons-material/Person'
import {
  // Typography,
  Grid,
} from '@mui/material'
// import { isPhoneNumber } from '../../utils/validators'
import { EditBase } from '../../components/base'
import { AccessLevelSelectInput } from '../../components/domains/admins'
import { ADMINS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
// import { AvatarInput } from '../../components/inputs'
import {
  FormBottomToolbarWithPermission,
  // BranchAutocompleteArrayInput,
} from '../../components/form'
import { Admin } from './type'

export const FormEdit = (): JSX.Element => {
  const [updateData, setUpdateData] = useState({} as Admin)
  const record = useRecordContext()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const redirect = useRedirect()
  const handleDialogClose = (): void => setOpen(false)
  const translate = useTranslate()

  const onError = useCallback(
    (error): void => {
      const errorMessage = error.response.data.message
      return notify(errorMessage || 'ra.validation.update_admin_fail', { type: 'error' })
    },
    [notify],
  )

  const onSuccess = useCallback(async (): Promise<void> => {
    notify('ra.notification.update_admin_success', { type: 'success' })
    redirect('/admins')
  }, [notify, redirect])

  const [update, { isLoading }] = useUpdate(undefined, undefined, { onError, onSuccess })

  const handleSubmit = (data): void => {
    const { access_branches: accessBranches, ...admin } = data

    admin.branch_ids = accessBranches

    setUpdateData(admin as Admin)
    setOpen(true)
  }

  const handleConfirm = useCallback(async (): Promise<void> => {
    await update('admins', {
      id: record.id,
      // data: { encType: 'multipart/form-data', ...updateData },
      data: {
        role_id: updateData?.role?.id,
        is_active: updateData?.is_active,
      },
    })
    handleDialogClose()
  }, [update, updateData, record])

  return (
    <SimpleForm onSubmit={handleSubmit} toolbar={<FormBottomToolbarWithPermission />}>
      <Confirm
        isOpen={open}
        loading={isLoading}
        title='Update admin'
        content='Are you sure you want to update this admin?'
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
      <Grid container spacing={1} justifyContent='center'>
        <Grid container item spacing={3} xs={12} sm={8} md={6}>
          {/* <Grid item xs={12} justifyContent='center' textAlign='center'>
            <AvatarInput
              source='avatar'
              label='Avatar'
              fallbackSource='full_path'
              placeholder={<PersonIcon />}
              accept='image/*'
            />
            <Typography sx={{ color: 'error.main' }} variant='caption' display='block' gutterBottom>
              Allowed *.jpeg, *.jpg, *.png, *.gif
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextInput
              source='firstname_th'
              label={`${ADMINS_FIELDS}.firstname_th`}
              fullWidth
              validate={[required()]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source='lastname_th'
              label={`${ADMINS_FIELDS}.lastname_th`}
              fullWidth
              validate={[required()]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source='username'
              label={`${ADMINS_FIELDS}.username`}
              fullWidth
              resettable
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              source='email'
              label={`${ADMINS_FIELDS}.email`}
              type='email'
              fullWidth
              validate={[required(), email()]}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ReferenceInput
              source='role.id'
              reference='roles'
              filter={{ is_active: true }}
              label={translate(`${ADMINS_FIELDS}.role`)}
              sort={{
                field: 'name',
                order: 'asc',
              }}
            >
              <AutocompleteInput optionText='name' validate={[required()]} size='small' />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} sm={6}>
            <AccessLevelSelectInput disabled />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <BranchAutocompleteArrayInput
              source='access_branches'
              depField='access_level'
              expectedValue='s'
              label='Select Branch'
              size='small'
            />
          </Grid> */}
          <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

export const AdminEdit = (): JSX.Element => {
  const transformAdmin = (data): object => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,
    const { confirm_password: confirmPassword, ...transformData } = data
    return transformData
  }

  return (
    <>
      <EditBase
        title={'resources.admins.edit.title'}
        redirect='list'
        listAction={{
          hasBackButton: true,
          hasShow: true,
        }}
        transform={transformAdmin}
        encType='multipart/form-data'
      >
        <FormEdit />
      </EditBase>
    </>
  )
}

export default AdminEdit
